<template>
    <div class="project-content-duplication">
        <design-2021-apprentice-multistep-form-wizard-form-header-component
            title="Kopiëren"
            :description="description">
        </design-2021-apprentice-multistep-form-wizard-form-header-component>

        <b-form-group
            class="project-duplicate-toggle-group"
            :label="labelText"
            label-for="project-duplicate-toggle-switch">
            <b-form-checkbox
                v-model="checked"
                name="project-duplication-toggle-button"
                switch
                @change="getGroupData">
            </b-form-checkbox>
        </b-form-group>

        <div class="project-select-filter">
            <b-form-group
                class="school-choice-group"
                v-if="schools.length > 2"
                label="Kies een school"
                label-for="school-choice-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="school-choice-select"
                    v-model="selectedSchool"
                    :options="schools"
                    :disabled="!checked"
                    @change="getGroupsForSelectedSchool">
                </b-form-select>
            </b-form-group>

            <b-form-group
                class="school-season-group"
                label="Kies een schooljaar"
                label-for="school-season-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="school-season-select"
                    v-model="selectedSchoolSeason"
                    :options="schoolSeasons"
                    :disabled="!checked"
                    @change="updateCourseList">
                </b-form-select>
            </b-form-group>

            <b-form-group
                class="course-group"
                label="Kies een vak"
                label-for="course-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="course-select"
                    v-model="selectedCourse"
                    :options="courses"
                    :disabled="!checked">
                </b-form-select>
            </b-form-group>

            <b-form-group
                class="group-choice-group"
                label="Kies een groep"
                label-for="group-choice-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="group-choice-select"
                    v-model="selectedGroup"
                    :options="filteredGroupList"
                    :disabled="selectedSchool === null && !checked"
                    @input="updateSelectedGroup">
                </b-form-select>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import Design2021ApprenticeMultiselectComponent from '../../../../common/design-2021-apprentice-multiselect-component.vue';

export default {
    name: 'design-2021-apprentice-multistep-wizard-duplicate-project-content-step-component',
    components: { Design2021ApprenticeMultiselectComponent },
    props: {
        value: Object,
        projectType: {
            type: Number,
            required: true,
        },
        seasonsIn: {
            type: Array,
            required: true,
        },
        coursesIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            description:
                'Schakel onderstaande optie in om een bestaande opdracht te kopiëren naar dit project. Wil je hier geen gebruik van maken, kan je deze stap overslaan en op “Volgende” klikken.',
            labelText: '',
            checked: false,
            schools: [{ value: null, text: 'Kies een school' }],
            selectedSchool: null,
            groupsList: [{ value: null, text: 'Kies een groep' }],
            selectedGroup: null,
            groupToCopyFrom: this.value,
            schoolSeasons: null,
            courses: null,
            selectedSchoolSeason: null,
            selectedCourse: null,
            groups: [],
            haveAccessToMultipleSchools: false,
        };
    },

    mounted() {
        switch (this.projectType) {
            case 2:
            case 7:
                this.labelText = 'Portfolio kopiëren van een bestaande groep';
                this.getSchoolsWithPortfolios();
                break;

            case 3:
                this.labelText = 'Quest kopiëren van een bestaande groep';
                this.getSchoolsWithQuests();
                break;

            case 6:
                this.labelText = 'Stage kopiëren van een bestaande groep';
                this.getSchoolsWithInternships();
                break;
        }

        if (this.schools.length === 2) {
            if (this.schools.findIndex((school) => school.value === this.$authUser.school.id) >= 0) {
                this.selectedSchool = this.$authUser.school.id;
                this.getGroupsForSelectedSchool(this.$authUser.school.id);
            } else {
                this.selectedSchool = this.schools[1].value;
                this.getGroupsForSelectedSchool(this.schools[1].value);
            }
        }
    },

    methods: {
        getGroupData(toggled) {
            if (!toggled) {
                this.updateSelectedGroup(null);
            }

            switch (this.projectType) {
                case 2:
                    this.getPortfolioGroupsForSelectedSchool(this.selectedSchool.value);
                    break;

                case 3:
                    this.getQuestGroupsForSelectedSchool(this.selectedSchool.value);
                    break;

                case 6:
                    this.getInternshipGroupsForSelectedSchool(this.selectedSchool.value);
                    break;
            }
        },

        getGroupsForSelectedSchool(value) {
            this.selectedSchoolSeason = null;
            this.selectedCourse = null;
            this.selectedGroup = null;

            switch (this.projectType) {
                case 2:
                    this.getPortfolioGroupsForSelectedSchool(value);
                    break;

                case 3:
                    this.getQuestGroupsForSelectedSchool(value);
                    break;

                case 6:
                    this.getInternshipGroupsForSelectedSchool(value);
                    break;
            }
        },

        getPortfolioGroupsForSelectedSchool(schoolId) {
            this.alert.saving('Groepen ophalen', 'Een moment, de groepen worden geladen');
            this.axios.get(this.routes.groupHavePortfolio(schoolId)).then(
                (response) => {
                    let groups = response.data.map((group) => {
                        return {
                            value: group.id,
                            text: group.name + ' (' + group.id + ')',
                            course_id: group.course_id,
                            season_id: group.season_id,
                        };
                    });

                    this.groups = [...groups];
                    this.getSchoolSeasons(groups);
                    this.getCourses(groups);

                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getQuestGroupsForSelectedSchool(schoolId) {
            this.alert.saving('Quests ophalen', 'Een moment, de quests worden geladen');
            this.axios.get(this.routes.groupHaveQuest(schoolId)).then(
                (response) => {
                    let groups = response.data.map((group) => {
                        return {
                            value: group.id,
                            text: group.name + ' (' + group.id + ')',
                            course_id: group.course_id,
                            season_id: group.season_id,
                        };
                    });

                    this.groups.push(...groups);
                    this.getSchoolSeasons(groups);
                    this.getCourses(groups);

                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getInternshipGroupsForSelectedSchool(schoolId) {
            this.alert.saving('Groepen ophalen', 'Een moment, de groepen worden geladen');
            this.axios.get(this.routes.groupHaveInternshipPortfolio(schoolId)).then(
                (response) => {
                    let groups = response.data.map((group) => {
                        return {
                            value: group.id,
                            text: group.name + ' (' + group.id + ')',
                            course_id: group.course_id,
                            season_id: group.season_id,
                        };
                    });

                    this.groups.push(...groups);
                    this.getSchoolSeasons(groups);
                    this.getCourses(groups);

                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getSchoolsWithQuests() {
            if (this.schools.length > 1 && this.projectType === 3) {
                return;
            }

            this.axios.get(this.routes.schoolHaveQuest()).then(
                (response) => {
                    const schoolsRetrieved = response.data.map((school) => {
                        return {
                            value: school.id,
                            text: school.name + ' (' + school.id + ')',
                        };
                    });
                    this.schools.push(...schoolsRetrieved);
                },
                () => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getSchoolsWithPortfolios() {
            if (this.schools.length > 1 && this.projectType === 2) {
                return;
            }

            this.axios.get(this.routes.schoolHavePortfolio()).then(
                (response) => {
                    if (response.data.length > 1) {
                        const schoolsRetrieved = response.data.map((school) => {
                            return {
                                value: school.id,
                                text: school.name + ' (' + school.id + ')',
                            };
                        });
                        this.schools.push(...schoolsRetrieved);
                    } else if (response.data.length === 1) {
                        this.selectedSchool = response.data.map((school) => {
                            return {
                                value: school.id,
                                text: school.name + ' (' + school.id + ')',
                            };
                        })[0];
                    } else {
                        this.checked = false;
                    }
                },
                () => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getSchoolsWithInternships() {
            if (this.schools.length > 1 && this.projectType === 6) {
                return;
            }

            this.axios.get(this.routes.schoolHaveInternship()).then(
                (response) => {
                    if (response.data.length > 1) {
                        const schoolsRetrieved = response.data.map((school) => {
                            return {
                                value: school.id,
                                text: school.name + ' (' + school.id + ')',
                            };
                        });
                        this.schools.push(...schoolsRetrieved);
                    } else if (response.data.length === 1) {
                        this.selectedSchool = response.data.map((school) => {
                            return {
                                value: school.id,
                                text: school.name + ' (' + school.id + ')',
                            };
                        })[0];
                    }
                },
                () => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateSelectedGroup(value) {
            if (value === null) {
                this.groupToCopyFrom.source_id = null;
                this.groupToCopyFrom.source_name = '';
            } else {
                this.groupToCopyFrom.source_id = value;
                this.groupToCopyFrom.source_name = this.filteredGroupList
                    .filter((group) => {
                        if (group.value === value) {
                            return group.text;
                        }
                    })
                    .slice(-1)[0].text;
            }

            this.$emit('input', this.groupToCopyFrom);
        },

        getSchoolSeasons(groups) {
            this.schoolSeasons = [{ value: null, text: 'Kies een schooljaar' }];

            let availableSchoolSeasons = groups.map((group) => group.season_id);
            if (availableSchoolSeasons.length > 0) {
                availableSchoolSeasons = [...new Set(availableSchoolSeasons)];
                availableSchoolSeasons = availableSchoolSeasons.map((schoolSeason) => {
                    let tempSeason = {};

                    for (const season of this.seasonsIn) {
                        if (season.id === schoolSeason) {
                            tempSeason.value = season.id;
                            tempSeason.text = season.season;
                            break;
                        }
                    }

                    return tempSeason;
                });
            }

            this.schoolSeasons.push(...availableSchoolSeasons);
        },

        getCourses(groups) {
            this.courses = [{ value: null, text: 'Kies een vak' }];

            let availableCourses = groups.map((group) => group.course_id);

            if (availableCourses.length > 0) {
                availableCourses = [...new Set(availableCourses)];
                availableCourses = availableCourses.map((courseId) => {
                    const text = this.coursesIn.find((course) => course.id === courseId).text;
                    return {
                        value: courseId,
                        text: text,
                    };
                });
            }

            this.courses.push(...availableCourses);
        },

        updateCourseList() {
            this.selectedCourse = null;
            this.selectedGroup = null;

            this.courses = [{ value: null, text: 'Kies een vak' }];

            let seasonalGroups = this.groups;
            seasonalGroups = seasonalGroups.filter((group) => group.season_id === this.selectedSchoolSeason);
            let seasonalCourses = [];
            if (seasonalGroups.length > 0) {
                seasonalCourses = seasonalGroups.map((group) => group.course_id);
                seasonalCourses = [...new Set(seasonalCourses)];
                seasonalCourses = seasonalCourses.map((courseId) => {
                    const text = this.coursesIn.find((course) => course.id === courseId).name;
                    return {
                        text: text,
                        value: courseId,
                    };
                });
            }

            this.courses.push(...seasonalCourses);
        },
    },

    computed: {
        filteredGroupList() {
            let groupsList = [{ value: null, text: 'Kies een groep' }];
            let groups = this.groups;

            if (this.selectedSchoolSeason !== null) {
                groups = groups.filter((group) => group.season_id === this.selectedSchoolSeason);
            }

            if (this.selectedCourse !== null) {
                groups = groups.filter((group) => group.course_id === this.selectedCourse);
            }

            if (groups.length > 0) {
                groupsList.push(...groups);
            }

            return groupsList;
        },
    },
};
</script>

<style scoped lang="scss">
select {
    margin-bottom: 0;
}

.project-duplicate-toggle-group {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: $grid-gutter-width;

    ::v-deep label {
        margin-bottom: 0;
    }
}

.project-select-filter {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: $grid-gutter-width;
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .project-select-filter {
        .form-group {
            margin-bottom: 0;
        }
    }
    .school-season-group {
        flex: 0 0 200px;
    }

    .course-group,
    .group-choice-group {
        flex: 0 0 350px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .school-choice-group,
    .group-choice-group {
        max-width: 355px;
    }
}
</style>
